export type PendingWorkResponse = {
  total: number;
  records: number | null;
  transfers: number | null;
  requests: number | null;
  salesPendingPayment: number | null;
};

export const EMPTY_PENDING_WORK: PendingWorkResponse = {
  total: 0,
  records: null,
  transfers: null,
  requests: null,
  salesPendingPayment: null,
};
